module.exports = __webpack_public_path__ + "static/media/Mr_thy_lines.b5ac54dd.png";